/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react"
import { Backdrop, CircularProgress, Typography } from "@mui/material"
import useStyles from "./useStyles"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import DetailsBox from "../../../components/Boxes/DetailsBox"
import configBoxes from "../../../components/Boxes/config/config"
import { SuborganizationsBox } from "../../../components/Boxes/SuborganizationsBox"
import { BoxTopes } from "../../../components/Boxes/Params"
import { getSubscriptionDetails } from "../../../redux/actions/eventanilla"
import BreadcrumbsComponent from "./Breadcrumbs/Breadcrumbs"

export const CommunicationDetails = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()

  const details = useSelector((state) => state.eventanilla.detailsSubscription)
  const [loading, setLoading] = useState(false)

  const getDetails = async () => {
    setLoading(true)
    await dispatch(getSubscriptionDetails(id))
    setLoading(false)
  }

  useEffect(() => {
    getDetails()
  }, [id])

  function formatCUIT() {
    return id.toString().length === 11
      ? `${id.slice(0, 2)}-${id.slice(2, 10)}-${id.slice(10)}`
      : id
  }
  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


      {details && !loading && (
        <>
          <BreadcrumbsComponent/>
          <div className={classes.boxtitle}>
            <Typography className={classes.title}>
              Información CUIT: {formatCUIT()}
            </Typography>
          </div>
          <DetailsBox data={details.details} config={configBoxes.details} />
          <SuborganizationsBox
            data={details.customerSuborgCommSubscriptionsVEList}
            config={configBoxes.suborganizations}
          />
          <BoxTopes appParameters={details.statusHistory} orderDesc={true} />
        </>
      )}
    </div>
  )
}
